import React from 'react';
import { Route, useLocation } from 'react-router-dom';
import SlideRoutes from 'react-slide-routes';
import { useAppContext, IRoute } from '@front-activerse/common-components';
import UnauthorizedException from '../Unauthorized/UnauthorizedException';

interface IUserMealsPage {
  descendantRoutes: IRoute[];
  mealsNavigation: {
    path: string;
    translationKey: string;
  }[];
}

export const UserMealsPage: React.FC<IUserMealsPage> = ({ descendantRoutes, mealsNavigation }) => {
  const {
    consts: { SLIDE_ROUTES_DURATION },
  } = useAppContext();
  const location = useLocation();
  const aiAccess = sessionStorage.getItem('aiAccess');
  const dietAccess = sessionStorage.getItem('dietAccess');

  if (
    location.pathname !== '/meals/user-meals' &&
    !(aiAccess === 'true' || dietAccess === 'true')
  ) {
    return <UnauthorizedException mealPlanNavigation={mealsNavigation} />;
  }

  return (
    <SlideRoutes duration={+SLIDE_ROUTES_DURATION} animation="slide" destroy={false}>
      {descendantRoutes.map((route: IRoute) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </SlideRoutes>
  );
};

export default UserMealsPage;
